import { useEffect, useState } from 'react';
import { Modal, Form, Input, Select, Spin } from 'antd';
import { FormattedMessage } from 'react-intl';
import { BlueButton } from '@share/components';
import { useSelector } from 'react-redux';
import { ILoginState } from '@share/store/slices';

const { Option } = Select;

const AddDepartment = (props: any) => {
  const { isOpen, setIsOpen, userData, onSave, intl } = props;
  const login = useSelector((state: { loginStore: ILoginState }) => state.loginStore);
  const { account } = login;
  const buttonColor = account?.buttonColor;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values: any) => {
    values.id = userData?.departmentId;
    values.activeState = userData?.activeState ? userData?.activeState : values?.activeState;
    setLoading(true);
    try {
      await onSave(values);
      setIsOpen(false);
    } catch (error) {
      console.error('Error parsing hotels data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userData) {
      form.setFieldsValue(userData);
    }
  }, [userData]);

  return (
    <Modal
      visible={isOpen}
      title={userData?.departmentId ? intl.formatMessage({ id: 'department.edit' }) : intl.formatMessage({ id: 'department.add' })}
      onCancel={() => setIsOpen(false)}
      footer={[
        <div className="p-2 d-flex justify-content-end align-items-center">
          <BlueButton 
            block
            size="large"
            type="primary"
            key="cancel"
            className={`btn mb-0 commonBlueBtn ${buttonColor ? '' : 'commonBlueBtn_Outline'}`}
            onClick={() => setIsOpen(false)}
          >
            <FormattedMessage id="cancel.button" />
          </BlueButton>
          <BlueButton
            block
            size="large"
            type="primary"
            key="submit"
            htmlType="submit"
            className="btn btn-primary commonBlueBtn"
            onClick={form.submit}
            loading={loading}
          >
            <FormattedMessage id="save.changes" />
          </BlueButton>
        </div>,
      ]}
    >
      <Spin spinning={loading}>
        <Form
          form={form}
          initialValues={{ 
            activeState: userData?.activeState ?? 1,
            departmentName: userData?.departmentName
          }}
          onFinish={onFinish}
          layout="vertical"
        >
         <div className="row">
              <div className="col-lg-6">
                <Form.Item
                label="Department Name"
                name="departmentName"
                rules={[{ required: true, message: intl.formatMessage({ id: 'department.name.required' }) }]}
              >
                <Input placeholder="Department name" className="form-control form-control-lg" />
              </Form.Item>

               </div>
              <div className="col-lg-6">
                <Form.Item label="Status" name="activeState">
                  <Select defaultValue="Active" className="customSelect">
                    <Option value={1}><FormattedMessage id='active' /></Option>
                    <Option value={0}><FormattedMessage id='inactive' /></Option>
                  </Select>
                </Form.Item>
               </div>
            </div>
        </Form>
      </Spin>
    </Modal>
  );
};

export { AddDepartment };
